export const transcriptionChunksToCleanString = (
  transcriptionChunks: string[],
) =>
  transcriptionChunks
    .join(' ')
    // eslint-disable-next-line sonarjs/slow-regex
    .replace(/\s+([.,!?;:])/g, '$1')
    .replace(/\s{2,}/g, ' ')
    .trim();
